import { useApiClient } from '~/api-client';
import { DexActivityTabResource, DexActivityTabView } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';

// How often an open DEX Activity tab refreshes
export const DEX_ACTIVITY_TAB_REFETCH_INTERVAL = 5000;

export function getDexActivityQueryKey(eventId?: number) {
    return ['dex-activity', eventId] as const;
}

type DexActivityQueryOptions = {
    enabled?: boolean;
    refetchInterval?: number | ((data: DexActivityTabView | undefined) => number);
    refetchIntervalInBackground?: boolean;
    retry?: boolean;
};

export function useEventDexActivityQuery(props: {
    eventId?: number;
    queryOptions?: DexActivityQueryOptions;
}) {
    const apiClient = useApiClient();
    const { queryOptions } = props;
    return useQuery(
        getDexActivityQueryKey(props.eventId),
        () => {
            return apiClient
                .request<DexActivityTabResource.GetDexActivityTab>({
                    method: 'POST',
                    url: `dex_activity_tab`,
                    data: {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        eventId: props.eventId!,
                    },
                })
                .then((resp) => resp.data.data);
        },
        {
            enabled: queryOptions?.enabled,
            refetchInterval: queryOptions?.refetchInterval ?? DEX_ACTIVITY_TAB_REFETCH_INTERVAL,
            refetchIntervalInBackground: queryOptions?.refetchIntervalInBackground,
            retry: queryOptions?.retry,
        }
    );
}
